<script>
  import { onMount } from "svelte";
  import { Button, TextInput } from "carbon-components-svelte";

  import AnonymizationList from "../components/AnonymizationList.svelte";
  import { fetchWithSession } from "lib/util/fetchWithSession.js";

  const urlParams = new URLSearchParams(window.location.search);
  const idAnonymization = urlParams.get("idAnonymization");
  let name = "";

  function updateName() {
    fetchWithSession(
      `/api/damprojects/setDAMAnonymizationPresetName/${idAnonymization}`,
      {
        method: "POST",
        body: JSON.stringify({ name: name }),
      }
    );
  }

  onMount(() => {
    fetchWithSession(
      `/api/damprojects/DAMAnonymizationPresets/${idAnonymization}`
    )
      .then((res) => res.json())
      .then((data) => {
        name = data.name;
      })
      .catch((err) => {
        console.log(err);
      });
  });
</script>

<TextInput labelText="Name" id="name" name="name" bind:value={name}></TextInput>
<Button on:click={updateName}>Save</Button>
<AnonymizationList {idAnonymization} preset editable></AnonymizationList>
